module.exports = __webpack_public_path__ + "img/BEASCNSHXXX.100b707e.png";